// toast-modal.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-toast-modal',
  template: `
    <div class="p-6 text-center">
      <h2 class="text-xl font-semibold mb-3">{{ data.title }}</h2>
      <p>{{ data.message }}</p>
      <button mat-button color="primary" class="mt-4" (click)="close()">OK</button>
    </div>
  `,
})
export class ToastModalComponent {
  constructor(
    private dialogRef: MatDialogRef<ToastModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  close() {
    this.dialogRef.close();
  }
}
